module.exports = __webpack_public_path__ + "static/img/picture.17d45fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/picture.png
// module id = SEPK
// module chunks = 44